const routes = {
  home: '/',
  projects: '/projects',
  about: '/about',
  postDetail: '/post-detail',
  temp: '/temp',
  cV: '/my-cv',
  editCv: '/edit-cv',
  flashCard: '/flash-card',
  createPost: '/create-post',
  projectDetail: '/project-detail',
  notePage: '/note',
  music: '/music',
  login: '/login',
  post: '/post',
  notFound: '*',
  tipDetail: '/tip-detail',
  tipspage: '/tips-page',
  productDetail: '/product-detail',
  shop: '/shop',
  service: '/service',
  projectTypes: '/project-types',
};
export default routes;
